var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { HeaderContent as Content, HeaderWrapper as Wrapper, Heading, Heading2 } from './Layout.styled';
import { headerCollapse, pageHeader as pageHeaderCss } from '../styles/legacy';
import { getAutomation, getDebug, getStyleNames, useCitrusDebug } from '@citrus/runtime';
import { useLocalization, useTheme } from '@citrus/user';
import { capitalize, isNotNilOrEmpty } from '@pcty/utils';
import { css as emotionCss, cx } from 'emotion';
import localizationMap from '../localization';
import HeaderTitle from './headerSubComponents/Title';
import BackButton from './headerSubComponents/BackButton';
import ActionArea from './headerSubComponents/ActionArea';
var VERSION = '6.7.2';
var Header = React.forwardRef(function (_a, ref) {
    var _b;
    var actionAreaBreakpoint = _a.actionAreaBreakpoint, as = _a.as, automationId = _a.automationId, className = _a.className, css = _a.css, headerAddOn = _a.headerAddOn, id = _a.id, onBack = _a.onBack, _c = _a.pageHeader, pageHeader = _c === void 0 ? false : _c, renderActionArea = _a.renderActionArea, title = _a.title, __TYPE = _a.__TYPE, other = __rest(_a, ["actionAreaBreakpoint", "as", "automationId", "className", "css", "headerAddOn", "id", "onBack", "pageHeader", "renderActionArea", "title", "__TYPE"]);
    var isCitron = useTheme().citrus2022;
    var debug = useCitrusDebug();
    var Component = as === 'h2' ? Heading2 : Heading;
    var lang = useLocalization(localizationMap);
    var emotionObj = (_b = {},
        _b[emotionCss(pageHeaderCss)] = pageHeader,
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b[emotionCss('padding-left: 22px;')] = !!onBack,
        _b);
    var styleNames = {
        pageHeaderCss: emotionObj[emotionCss(pageHeaderCss)],
    };
    if (actionAreaBreakpoint) {
        emotionObj[emotionCss(headerCollapse[actionAreaBreakpoint])] = true;
        styleNames['headerCollapse' + capitalize(actionAreaBreakpoint)] =
            emotionObj[emotionCss(headerCollapse[actionAreaBreakpoint])];
    }
    var classes = cx(emotionObj, className || '');
    return (React.createElement(Wrapper, __assign({ className: "".concat(classes, " citron-header-wrapper"), id: id, ref: ref, styleNames: getStyleNames(styleNames) }, other, getAutomation(automationId), getDebug(debug, __TYPE, VERSION)),
        React.createElement(Content, null,
            onBack && (React.createElement(BackButton, { automationId: automationId, id: id, isCitron: isCitron !== null && isCitron !== void 0 ? isCitron : false, lang: lang, onBack: onBack })),
            React.createElement(Component, __assign({}, getAutomation(automationId, 'title')), title && React.createElement(HeaderTitle, { headerAddOn: headerAddOn, title: title }))),
        renderActionArea && (React.createElement(ActionArea, { actionAreaBreakpoint: actionAreaBreakpoint, renderActionArea: renderActionArea }))));
});
Header.defaultProps = {
    __TYPE: 'Header',
};
export default Header;
